export type JwtPayload = {
    exp?: number;
    iat?: number;
    user?: unknown;
    [key: string]: unknown;
};

export function decodeJwtPayload(accessToken?: string): JwtPayload | undefined {
    try {
        const payload = accessToken?.split(".")[1];
        if (!payload) {
            return undefined;
        }
        const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
        const binary = window.atob(normalizedPayload);
        const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
        const json = new TextDecoder("utf-8").decode(bytes);
        return JSON.parse(json) as JwtPayload;
    } catch {
        return undefined;
    }
}

export function getJwtRemainingSeconds(accessToken?: string): number {
    const payload = decodeJwtPayload(accessToken);
    if (!payload?.exp) {
        return 0;
    }
    return Math.max(0, Math.floor(payload.exp - Date.now() / 1000));
}

export function formatTokenRemainingTime(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
